import { combineReducers } from 'redux';

import downloadsReducer from '../downloads/store/reducers';
import referencesReducer from '../references/store/reducers';

export default combineReducers({
  downloads: downloadsReducer,
  references: referencesReducer,
});
